/* Nightpass - regroupe quantite + boutons d'achat sur une meme ligne */
(function () {
  function group() {
    var qty = document.querySelector('.product__info-container .product-form__quantity');
    if (!qty || qty.closest('.np-buyrow')) return;
    var form = qty.nextElementSibling;
    if (!form) return;
    var row = document.createElement('div');
    row.className = 'np-buyrow';
    qty.parentNode.insertBefore(row, qty);
    row.appendChild(qty);
    row.appendChild(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', group);
  } else { group(); }
  document.addEventListener('shopify:section:load', group);
})();
